


















import Vue from 'vue';
import SvgIcon from '../SvgIcon/SvgIcon.vue';

export default Vue.extend({
    computed: {
        hasIcon(): boolean {
            const result = (this as any).$slots?.left?.find(
                (i: any) =>
                    i.componentOptions?.Ctor?.extendOptions?.name ===
                    SvgIcon.name
            );

            return typeof result !== 'undefined';
        },
    },
});
